import { IUser } from "@formant/core/model/IUser";

export function isPersona(user: IUser): boolean {
    return user.description !== undefined && user.description !== null;
}
